import {useState, useContext, useEffect} from 'react';
import { H3, Panel, Flex, FlexItem, Button, Text, Box, Table } from '@bigcommerce/big-design';
import { AddIcon, EditIcon, CheckIcon, DeleteIcon } from '@bigcommerce/big-design-icons';
import FieldForm from './FieldForm';

export default function FieldTable({ modifiers, setModifiers, setHasChanged }) {

    const [isOpen, setIsOpen] = useState(false);
    const [field, setField] = useState(null);

    useEffect(() => {
        if (isOpen === false) {
            setField(null);
        }
    }, [isOpen]);

    const onDragEnd = (from, to) => {
        let tempFields = [...modifiers];
        let tempField = tempFields.splice(from, 1);
        tempFields.splice(to, 0, tempField[0]);
        tempFields.forEach((f, i) => {
            f.sort_order = i + 1;
            f.updated = true;
        });
        setModifiers(tempFields);
    };

    const handleAdd = () => {
        setField({
            id: `field_${Math.random().toString(36).substring(7)}`,
            display_name: '',
            required: false,
            type: 'text',
            option_values: [],
            config: {
                checkbox_label: ''
            }
        });
        setIsOpen(true);
    };

    const handleEdit = (fieldId) => {
        const toEdit = modifiers.find(m => m.id === fieldId);
        setField({...toEdit});
        setIsOpen(true);
    };

    const handleDelete = async (e, fieldId) => {
        e.preventDefault();
        let tempFields = [...modifiers];
        let index = tempFields.findIndex(f => f.id === fieldId);
        tempFields[index].deleted = true;
        tempFields[index].updated = true;
        setModifiers(tempFields);
        setHasChanged(true);
    };

    const handleSave = async (field) => {
        let tempFields = [...modifiers];
        let index = tempFields.findIndex(f => f.id === field.id);
        if (index === -1) {
            tempFields.push({
                ...field,
                updated: true,
                sort_order: tempFields.length + 1
            });
        }
        else {
            tempFields[index] = field;
            tempFields[index].updated = true;
        }
        setModifiers(tempFields);
        setHasChanged(true);
        setIsOpen(false);
    };

    const FormActions = () => {
        return (
            <Box className='form-table-actions'>
                <Button onClick={handleAdd} variant='primary' iconLeft={<AddIcon />}>Add New Field</Button>
            </Box>
        )
    }

    return (
        <Box marginTop={'large'}>
            <Table
                columns={[
                    { header: 'Display Name', hash: 'display_name', render: ({ display_name }) => display_name },
                    { header: 'Type', hash: 'type', render: ({ type }) => type },
                    { header: 'Required', hash: 'required', render: ({ required }) => required ? <CheckIcon /> : <Text></Text> },
                    { header: 'Actions', hash: 'actions', align: 'right', render: ({ id, display_name }) => {
                        const isRequired = (display_name === 'Name' || display_name === 'Email' || display_name === 'Location');
                        return (
                            <Flex>
                                <FlexItem><Button onClick={() => handleEdit(id)} variant='subtle' iconOnly={<EditIcon title="edit" />} disabled={isRequired}></Button></FlexItem>
                                <FlexItem><Button onClick={(e) => handleDelete(e, id)} variant='subtle' iconOnly={<DeleteIcon title="delete" />} disabled={isRequired}></Button></FlexItem>
                            </Flex>
                        )} },
                ]}
                items={modifiers.filter(m => !m.deleted)}
                key={`table`}
                onRowDrop={onDragEnd}
                actions={<FormActions />}
            /> 
            {isOpen && field && <FieldForm key={`field_${Math.random().toString(36).substring(7)}`} field={field} isOpen={isOpen} setIsOpen={setIsOpen} handleSave={handleSave} />}
        </Box>
    );
}
